/**
 * The query keys the Supporters section shares.
 *
 * Every key names the organization, because switching organization - a Super
 * Admin's switch, or staff viewing another - does not clear the cache:
 * without it one organization's supporters would show under the other's name
 * (I3, P9). A list key carries the list it reads and exactly the query it
 * sends, so every parameter that changes the reply - search, sort, direction,
 * page and page size - changes the key (NF4). Nothing invalidates these keys:
 * the section has no write.
 */
import type { SupportersQuery } from './useSupporters';
import type { SupporterListType } from './useSupportersParams';

/** Everything the section reads, for one organization. */
export const supportersKey = (organizationId: string | null) =>
  ['supporters', organizationId] as const;

/** One page of the followed or the invited list, keyed by the request it sends. */
export const listKey = (
  organizationId: string | null,
  type: SupporterListType,
  query: SupportersQuery,
) => [...supportersKey(organizationId), 'list', type, query] as const;

/** The totals behind the four cards. */
export const summaryKey = (organizationId: string | null) =>
  [...supportersKey(organizationId), 'summary'] as const;
